export default __webpack_public_path__ + "static/media/weapon4.13e1bf0f.png";